import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Result } from 'app/core/models/result';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AuditTemplateAddModel } from 'app/audit-template/models/audit-template-add.model';
import { AuditTemplateService } from 'app/audit-template/services/audit-template.service';
import { AuditCategoryModel } from '../../models/audit-category.model';

@Component({
  selector: 'app-audit-template-add',
  templateUrl: './audit-template-add.component.html',
  styleUrls: ['./audit-template-add.component.css']
})
export class AuditTemplateAddComponent implements OnInit {

    headerTitle: IHeaderTitle;
    errors: string[];
    submitAttempt: boolean = false;
    addAuditTemplateFormGroup: FormGroup;
    auditCategoryList: AuditCategoryModel[];

    constructor(
        private auditTemplateService: AuditTemplateService,
        private fb: FormBuilder,
        private location: Location,
        private router: Router
    ) { }

    ngOnInit() {
        this.headerTitle = {
            title: 'Add Audit Template', breadcrumbs: [
                { title: 'Audit Templates', url: ['/audit-template'] }
            ]
        }
        this.auditTemplateService.getAuditCategories().subscribe(
            result => {
                this.auditCategoryList = result;
            },
            error => {
                this.errors = error.errorList;
            }
        );
        this.initializeForm();
    }

    initializeForm(): void {
        this.addAuditTemplateFormGroup = this.fb.group(
            {
                description: ['', Validators.required],
                auditCategoryId: ['', Validators.required],
                isActive: [true, Validators.required],
                recurrence: ['']
            }
        );
    }

    addAuditTemplate(): void {
        this.submitAttempt = true;
        if (this.addAuditTemplateFormGroup.valid) {
            const formValue = this.addAuditTemplateFormGroup.value;
            this.auditTemplateService.create(formValue).subscribe(
                auditTemplateId => {
                    this.router.navigate(['./audit-template/' + auditTemplateId]);
                },
                error => {
                    this.errors = (<Result>error).errorList;
                });
        }
    }
    

    onBack(): void {
        this.location.back();
    }

}
